import { useTranslation } from "react-i18next";
import { AccountFrame } from "@/components/layout/ConsoleShell";
import { PageHeader } from "@/components/layout/PageHeader";
import { OrganizationCreateForm } from "./OrganizationCreateForm";

export function OrganizationRequiredPage() {
  const { t } = useTranslation();
  return (
    <AccountFrame>
      <div className="console-page space-y-6">
        <PageHeader title={t("organizationRequired.title")} description={t("organizationRequired.description")} />
        <div className="max-w-3xl">
          <OrganizationCreateForm />
        </div>
      </div>
    </AccountFrame>
  );
}
